import React from 'react';
import { connect } from 'react-redux';
import Base from './Base';
// import BulletPoint from './BulletPoint';

import { fetchUpgradePopup } from '../../../actions/upgrade-to-power-actions';

const ProClubCollegeHeader = props => {
    const { upgradePopup } = props;
    const { data } = upgradePopup;
    const title = `${props.clubName ? `Upgrade <span> ${props.clubName}</span> to <span>College Coach Subscription</span>` : `Upgrade to College Coach Subscription`}`;
    const subText = (
        <React.Fragment>
            {data.checkoutbulletpoints.map(bulletpoint => (
                <div>{bulletpoint}</div>

            ))}

        </React.Fragment>
    );
    return (
        <Base
            title={title}
            subText={subText}
            {...props}
        />
    );
};

const mapStateToProps = ({ upgradePopup }) => {
    return { upgradePopup };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchUpgradePopup: (prismicUid) => dispatch(fetchUpgradePopup(prismicUid)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProClubCollegeHeader);
